app.service('suggestedProductsSection', function (lastViewed, lazyLoad, viewPoint) {

	let $self, $content, $suggestedProductsList;

	function init() {
		setElements();
		setEvents();
		const productIds = lastViewed.getProducts();
		loadSuggestedProducts(productIds);
	}

	function setElements() {
		$self = $('#suggested-products');
		$content = $self.find('.section-content');
		$suggestedProductsList = $self.find('.suggested-products-list');
	}

	function setEvents() {
		$self.on('click', '.js-clear-suggested-products', function handleClearSuggestedProductsClick() {
			lastViewed.clear();
			$self.addClass('is-hidden');
		});
	}

	function loadSuggestedProducts(productIds) {

		let requests = loadAllProducts(productIds);

		$.when(...requests)
			.then((...responses) => {

				if (typeof responses[0] === "string") {
					$suggestedProductsList.html(responses[0]);
				} else {
					$suggestedProductsList.html(responses.map(p => p[0]).join(''));
				}

				if ($suggestedProductsList.is(":empty")) {
					$self.addClass('is-hidden');
				} else {
					lazyLoad.update();
					setUA();
				}
			})
			.fail(() => {
				$content.text("[suggestedProducts] Błąd inicjalizacji modułu. Odśwież stronę aby spróbować ponownie.");
			})
			.always(() => {
				$self.removeClass('loading');
			});
	}

	function loadAllProducts(productIds) {
		return productIds.map(productId =>
			$.ajax({
				url: '/web-cached/search-suggestions/single-suggested-product.ltr',
				data: {
					productId
				}
			})
		);
	}

	function setUA() {
		viewPoint.set({
			element: $self,
			height: 0.6 * $self.height(),
			callback() {
				UA.searchInteraction('Zerowe wyniki wyszukiwan', 'Ostatnio ogladane', 'Wyswietlenie');
			}
		});

		$suggestedProductsList.on('click', 'a', function () {
			const productCode = $(this).closest('.product-carousel-item').find('.productPlu').val();
			UA.searchInteraction('Zerowe wyniki wyszukiwan', 'Ostatnio ogladane', 'Klikniecie', productCode);
		});
	}

	return {
		init
	};
});